/** @format */

export interface AnalyticsError {
  errorCode: string;
  errorMessage: string;
}
